<app-generic-container>
    <!-- Usamos el panel genérico -->
    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">
        <dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
            (onEditorPreparing)="onEditorPreparing($event)">

            <!-- Definición de las columnas -->

            <dxi-column dataField="title" caption="Título"></dxi-column>
            <dxi-column dataField="companies[0].name" caption="Empresa"></dxi-column>
            <dxi-column dataField="published" caption="Estado" alignment="center" dataType="string" sortOrder="desc"
                [calculateDisplayValue]="calculatePublished"
                [lookup]="{ dataSource: [{ value: true, text: 'Publicado' }, { value: false, text: 'Borrador' }], valueExpr: 'value', displayExpr: 'text' }">
            </dxi-column>
            <dxi-column dataField="publisherData.name" caption="Publicador" alignment="center"
                sortOrder="desc"></dxi-column>
            <dxi-column dataField="publishedOn" caption="Fecha publicación" alignment="center" dataType="date"
                format="dd/MM/yyyy"></dxi-column>
            <dxi-column dataField="modifiedOn" caption="Fecha modificación" alignment="center" dataType="date"
                format="dd/MM/yyyy"></dxi-column>
            <!-- Templates -->
            <ng-container *ngIf="isCrud">
                <dxi-column dataField="bulletinBoard1" caption="Acciones" [allowFiltering]="false"
                    [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
                <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                    <button rel="tooltip" type="button" class="btn btn-success btn-action"
                        (click)="onClickEdit(data.data)">
                        <i class="material-icons">edit</i>
                    </button>
                    <button rel="tooltip" type="button" class="btn btn-danger btn-action"
                        (click)="unpublishAnnouncement(data.data)">
                        <i class="material-icons">close</i>
                    </button>
                </ng-container>
            </ng-container>

            <!-- Añadir nuevos -->
            <div *dxTemplate="let data of 'addNew'">
                <button class="btn btn-primary btn-sm btn-add" (click)="onClickEdit()">
                    <i class="material-icons">add</i>
                    <span class="d-none d-sm-inline-block">Nuevo</span>
                </button>
            </div>
        </dx-data-grid>

    </app-generic-panel>

    <br>
</app-generic-container>